module.exports = __webpack_public_path__ + "img/education.2db9d5fd.png";